// extracted by mini-css-extract-plugin
export default {"account":"PayoutDestination_account__jPZpr","accountName":"PayoutDestination_accountName__YPzDC"};